module.exports = __webpack_public_path__ + "img/61.d46e5f5f.jpg";